<template>
  <!-- photo modal (Figma "Step 4/5 Photo Modal"): photo or pdf, red X, prev / next at the bottom -->
  <Teleport to="body">
    <div v-if="current !== null && files[current]" class="fixed inset-0 z-[1060] flex items-center justify-center p-[16px] bg-[rgba(0,0,0,0.5)]"
      role="dialog" aria-modal="true" aria-label="Photo" @click.self="closeViewer">
      <div class="relative flex items-center justify-center w-full max-w-[900px] min-h-[70vh] max-h-[70vh] rounded-[10px] border-[5px] border-white bg-white overflow-hidden shadow-[0_10px_40px_rgba(0,0,0,0.25)]">
        <iframe v-if="files[current].mime === 'pdf'" :src="files[current].url" title="Document"
          class="block w-full h-[70vh] border-0" />
        <img v-else :src="files[current].url" :alt="files[current].title || altText"
          class="block w-full max-h-[70vh] object-contain bg-[#F4F4F6]">
        <button type="button" aria-label="Close" class="absolute top-[12px] right-[12px] w-[30px] h-[30px] flex items-center justify-center border-0 bg-transparent"
          @click="closeViewer">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="#EE5851" stroke-width="2.4" stroke-linecap="round" /></svg>
        </button>
        <div v-if="files.length > 1" class="absolute bottom-[14px] left-1/2 -translate-x-1/2 flex items-center gap-[12px]">
          <button type="button" aria-label="Previous photo" :disabled="current === 0"
            class="w-[26px] h-[26px] rounded-full flex items-center justify-center border-0"
            :class="current === 0 ? 'bg-transparent' : 'bg-[#F67280]'" @click="current--">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" :stroke="current === 0 ? '#999999' : '#FFFFFF'" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button type="button" aria-label="Next photo" :disabled="current >= files.length - 1"
            class="w-[26px] h-[26px] rounded-full flex items-center justify-center border-0"
            :class="current >= files.length - 1 ? 'bg-transparent' : 'bg-[#F67280]'" @click="current++">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" :stroke="current >= files.length - 1 ? '#999999' : '#FFFFFF'" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
// Full-screen viewer shared by PhotoGallery and the RQ documents card; v-model:index = the open file (null = closed)
export default {
  name: "PhotoViewer",
  props: {
    // [{ url, title?, mime?: 'pdf' | 'image' }]
    files: { type: Array, default: () => [] },
    index: { type: Number, default: null },
    altText: { type: String, default: "Photo" },
  },
  emits: ["update:index"],
  computed: {
    current: {
      get() { return this.index; },
      set(value) { this.$emit("update:index", value); },
    },
  },
  watch: {
    index(now, old) {
      if (now !== null && old === null) document.addEventListener("keydown", this.onKey);
      if (now === null) document.removeEventListener("keydown", this.onKey);
    },
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.onKey);
  },
  methods: {
    closeViewer() {
      this.current = null;
    },
    onKey(e) {
      if (e.key === "Escape") this.closeViewer();
      else if (e.key === "ArrowLeft" && this.current > 0) this.current--;
      else if (e.key === "ArrowRight" && this.current < this.files.length - 1) this.current++;
    },
  },
};
</script>
